import type { ComponentProps, ReactNode } from "react";
import { PageErrorState } from "@/components/shared/ErrorState";

interface FeedErrorStateProps {
    title?: string;
    message?: string;
    onRetry: () => void;
    actions?: ReactNode;
    scene?: ComponentProps<typeof PageErrorState>["scene"];
}

export function FeedErrorState({
    title = "We couldn't show dogs just now",
    message = "Try loading dogs again.",
    onRetry,
    actions,
    scene = "searching",
}: FeedErrorStateProps) {
    return (
        <PageErrorState
            className="min-h-0 py-16"
            title={title}
            description={message}
            onRetry={onRetry}
            actions={actions}
            scene={scene}
            headingLevel={2}
        />
    );
}
